var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "58px",
    viewBox: "0 0 34 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.97,0 C30.7714231,0 33.075802,2.02796106 33.1951451,4.59934765 L33.2,4.809 L33.2,52.567 C33.2,55.1668153 30.9691808,57.2640055 28.1960071,57.3725835 L27.97,57.377 L5.23,57.377 C2.4293979,57.377 0.124241164,55.3479491 0.00485660009,52.7766432 L0,52.567 L0,4.809 C0,2.2096078 2.23129474,0.112964815 5.00403045,0.00441531727 L5.23,0 L27.97,0 Z M27.97,1.2 L5.23,1.2 C3.06201627,1.2 1.31244047,2.72877334 1.20520915,4.62444185 L1.2,4.809 L1.2,52.567 C1.2,54.4853617 2.88205983,56.074798 5.02156426,56.1722644 L5.23,56.177 L27.97,56.177 C30.1383597,56.177 31.887583,54.6478279 31.9947919,52.7516116 L32,52.567 L32,4.809 C32,2.89054442 30.3187714,1.30213461 28.1785137,1.20473249 L27.97,1.2 Z M11.2128994,21.8097046 L11.3071068,21.8928932 L16.6,27.185 L21.8928932,21.8928932 C22.2834175,21.5023689 22.9165825,21.5023689 23.3071068,21.8928932 C23.6675907,22.2533772 23.6953203,22.8206082 23.3902954,23.2128994 L23.3071068,23.3071068 L18.015,28.6 L23.3071068,33.8928932 C23.6976311,34.2834175 23.6976311,34.9165825 23.3071068,35.3071068 C22.9466228,35.6675907 22.3793918,35.6953203 21.9871006,35.3902954 L21.8928932,35.3071068 L16.6,30.015 L11.3071068,35.3071068 C10.9165825,35.6976311 10.2834175,35.6976311 9.89289322,35.3071068 C9.53240926,34.9466228 9.50467972,34.3793918 9.80970461,33.9871006 L9.89289322,33.8928932 L15.185,28.6 L9.89289322,23.3071068 C9.50236893,22.9165825 9.50236893,22.2834175 9.89289322,21.8928932 C10.2533772,21.5324093 10.8206082,21.5046797 11.2128994,21.8097046 Z",
    id: "Shape",
    fill: "#1E5B53",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadConnection);
export default __webpack_public_path__ + "static/media/bad_connection.e87af15dc95fa90fdaafe85247b560ba.svg";
export { ForwardRef as ReactComponent };